import { rankWith, uiTypeIs } from '@jsonforms/core';
import type { GroupLayout, LayoutProps, RankedTester } from '@jsonforms/core';
import { withJsonFormsLayoutProps } from '@jsonforms/react';
import React from 'react';
import { JsonFormsLayout } from 'src/components/JsonForm/layouts/JsonFormLayout';
import { RenderChildren } from 'src/components/JsonForm/RenderChildren';

const GroupComponent = (props: LayoutProps) => {
    const layout = props.uischema as GroupLayout;

    return layout.elements.length > 0 ? (
        <JsonFormsLayout
            className="flex flex-col gap-2"
            visible={props.visible}
            enabled={props.enabled}
            path={props.path}
            uischema={props.uischema}
            schema={props.schema}
        >
            <RenderChildren layout={layout} schema={props.schema} path={props.path} enabled={props.enabled} />
        </JsonFormsLayout>
    ) : null;
};

export const GroupLayoutRenderer = withJsonFormsLayoutProps(React.memo(GroupComponent));

export const GroupLayoutTester: RankedTester = rankWith(10, uiTypeIs('Group'));
